export default {"src":"/_next/static/media/mission.e9a77764.svg","height":70,"width":70,"blurWidth":0,"blurHeight":0};